<template>
  <div id="weezypictures">
    <div id="content">
      <div>
        <h1 class="page-title">
          <i class="fal fa-camera"></i> Photos Weezy
        </h1>
      </div>
    </div>

    <div>
      <div
        class="wrapper mt2"
        v-if="pictures.length"
      >
        <div
          v-for="(picture, index) in pictures"
          :key="index"
          class="picture-container mb2"
        >
          <img
            class="fit-picture"
            :src="`https://api.weezy.soda-armatis.com/static-files/WeezyPictures/${picture.name}.png`"
            alt="photo"
          >
        </div>
      </div>
      <div
        class="mt2"
        v-else
      >
        Aucune photo disponible aujourd'hui
      </div>
    </div>
  </div>
</template>

<script>
import gameScoresTable from "@/components/gameScoresTable";
import http from "@/modules/request";

export default {
  name: "weezypictures",
  components: {
    gameScoresTable
  },
  data() {
    return {
      pictures: []
    };
  },
  mounted() {
    this.$parent.$refs.menubar.login = true;
    this.getPictures();
  },
  methods: {
    getPictures() {
      http
        .get("/publicpictures")
        .then(response => {
          this.pictures = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    errorToast(message) {
      this.$toast.open({
        duration: 3000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.wrapper {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: auto auto auto auto;
  /* 4 auto means 4 columns */
}

.fit-picture {
  margin-bottom: -40px;
}

.button-delete {
  margin-left: calc(50% - 45px);
}

.button-delete {
  right: 0;
  top: 0px;
  opacity: 0;
}

.picture-container:hover .button-delete {
  opacity: 1;
}
</style>